export default {"src":"/_next/static/media/toast-tick-icon.0be6fe98.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};